'use strict';

require('./index.styl');

require('../base/index.js');
require('../vendor/backbone');

const {
  critModules,
  nonCritModules,
  pageReadyModules,
} = require('./js_modules');

const jsInitializer = require('../initializers/js_initializer');

jsInitializer
  .addJsFiles(critModules, nonCritModules, pageReadyModules)
  .initialize();
